export default __webpack_public_path__ + "static/media/bus-dark.4877d928.svg";